import React from 'react'
function Skills__range({title,range}) {
  return (
    <div className="md:w-[45%] w-full">
      <div className="flex justify-between">
        <h1 className="font-semibold pl-1 pr-1">{title}</h1>
        <span className="font-semibold pl-1 pr-1">{range}%</span>
      </div>
      <div
        className="w-[100%] h-3 border-2 border-gray-400"
        style={{ borderRadius: "10px", marginBottom: "10px" }}
      >
        <div
          className="h-[100%]"
          style={{ borderRadius: "10px",width:`${range}%`,background:'rgb(245, 223, 78)' }}
        ></div>
      </div>
    </div>
  )
}

export default Skills__range